export interface AvatarProps {
  name: string;
}

/** Iniciales (máx. 2) a partir de un nombre, en mayúsculas. */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0]?.charAt(0) ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1]?.charAt(0) ?? "" : "";
  return (first + last).toUpperCase();
}

export function Avatar({ name }: AvatarProps): JSX.Element {
  return (
    <div className="avatar" aria-hidden="true" title={name}>
      {initials(name)}
    </div>
  );
}
